class UniversalCommentsController {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async list({ targetType, targetId, sort = 'latest', skip = 0, take = 20 } = {}) {
    const params = { targetType, targetId, sort, skip, take };
    const response = await this.apiService.get('/comments', { params });
    return response.data;
  }

  async create({ targetType, targetId, content, parentId, mediaUrl, gifUrl } = {}) {
    const payload = { targetType, targetId, content };
    if (parentId) payload.parentId = parentId;
    if (mediaUrl) payload.mediaUrl = mediaUrl;
    if (gifUrl) payload.gifUrl = gifUrl;
    const response = await this.apiService.requestWithRawJson('/comments', 'POST', payload);
    return response.data;
  }

  async update(commentId, { content } = {}) {
    const response = await this.apiService.requestWithRawJson(`/comments/${commentId}`, 'PATCH', { content });
    return response.data;
  }

  async delete(commentId) {
    const response = await this.apiService.delete(`/comments/${commentId}`);
    return response.data;
  }

  async like(commentId) {
    const response = await this.apiService.post(`/comments/${commentId}/like`);
    return response.data;
  }

  async unlike(commentId) {
    const response = await this.apiService.delete(`/comments/${commentId}/like`);
    return response.data;
  }

  async react(commentId, emoji) {
    const response = await this.apiService.requestWithRawJson(`/comments/${commentId}/reactions`, 'POST', { emoji });
    return response.data;
  }

  async unreact(commentId, emoji) {
    const response = await this.apiService.requestWithParams(`/comments/${commentId}/reactions`, 'DELETE', { emoji });
    return response.data;
  }
}

export default UniversalCommentsController;
